import React from "react";
import { Badge, Button, Drawer } from "antd";
import { useLocation } from "react-router-dom";
import CartView from "../screens/Cliente/Cart/CartView";
import { ShoppingCartOutlined, CloseOutlined } from "@ant-design/icons";

const BtnCarrito = ({ cartItems, disabled, text }) => {
  const [drawerVisible, setDrawerVisible] = React.useState(false);
  const { pathname } = useLocation();

  // El carrito nunca debe quedarse abierto al cambiar de pantalla
  React.useEffect(() => {
    setDrawerVisible(false);
  }, [pathname]);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onClose = () => {
    setDrawerVisible(false);
  };

  const productosLength = cartItems && cartItems.productos ? cartItems.productos.length : 0;
  const serviciosLength = cartItems && cartItems.servicios ? cartItems.servicios.length : 0;
  const items = productosLength + serviciosLength;

  // En móvil (≤850px) no renderizamos el drawer porque el carrito se maneja desde el bottom bar
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 850;

  return (
    <>
      <Badge count={items}>
        <Button
          icon={<ShoppingCartOutlined />}
          onClick={showDrawer}
          disabled={disabled || items === 0}
        >
          {text === false ? null : "Ir a ver el carrito"}
        </Button>
      </Badge>
      {!isMobile && (
        <Drawer
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  background: "#f0fdf4",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ShoppingCartOutlined style={{ fontSize: 18, color: "#1dbf73" }} />
              </span>
              <div style={{ lineHeight: 1.25 }}>
                <div style={{ fontWeight: 700, fontSize: "1.1rem", color: "#1f2937" }}>Tu carrito</div>
                {items > 0 && (
                  <div style={{ fontWeight: 400, fontSize: 13, color: "#6b7280" }}>
                    {items} {items === 1 ? "artículo" : "artículos"}
                  </div>
                )}
              </div>
            </div>
          }
          placement="right"
          closable={false}
          extra={
            <Button type="text" shape="circle" aria-label="Cerrar carrito" icon={<CloseOutlined />} onClick={onClose} />
          }
          onClose={onClose}
          open={drawerVisible}
          width={420}
          styles={{
            body: { padding: 0, height: "100%", display: "flex", flexDirection: "column" },
            header: { borderBottom: "1px solid #eef2f6", padding: "16px 20px", minHeight: 72 },
          }}
        >
          <CartView cartItems={cartItems} onClose={onClose} isDrawer={true} />
        </Drawer>
      )}
    </>
  );
};

export default BtnCarrito;
